module.exports = __webpack_public_path__ + "img/image10.f860573d.webp";